// Client-side calls to the Netlify Functions. The Gemini key never touches
// the browser — all model calls happen server-side behind these endpoints.
import type {
  DiscoveryRequest,
  DiscoveryResponse,
  MatchRequest,
  MatchResponse,
  NaukriSearchRequest,
  NaukriSearchResponse,
} from "./types";

const BASE = "/.netlify/functions";

async function postJson<TReq, TRes>(path: string, body: TReq): Promise<TRes> {
  const res = await fetch(`${BASE}/${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = (await res.json().catch(() => ({}))) as
    | TRes
    | { error?: string };
  if (!res.ok) {
    const message =
      (data as { error?: string }).error ?? `Request failed (${res.status}).`;
    throw new Error(message);
  }
  return data as TRes;
}

export function discoverCompanyJobs(
  req: DiscoveryRequest,
): Promise<DiscoveryResponse> {
  return postJson<DiscoveryRequest, DiscoveryResponse>(
    "career-discovery",
    req,
  );
}

export function matchWithResume(req: MatchRequest): Promise<MatchResponse> {
  return postJson<MatchRequest, MatchResponse>("match-resume", req);
}

export function searchNaukri(
  req: NaukriSearchRequest,
): Promise<NaukriSearchResponse> {
  return postJson<NaukriSearchRequest, NaukriSearchResponse>(
    "naukri-search",
    req,
  );
}
